const setUploadTestResultImageData = (state, uploadTestResultImageData) => {
  Object.assign(state, { uploadTestResultImageData })
}

const resetCurrentChannel = state => {
  Object.assign(state, { currentChannel: {} })
}

const setCurrentChannel = (state, doc) => {
  const currentChannel = { id: doc.id, ...doc.data() }
  Object.assign(state, { currentChannel })
}

const setRawCurrentChannel = (state, currentChannel) => {
  Object.assign(state, { currentChannel })
}

const setControlChannel = (state, controlChannel = {}) => {
  Object.assign(state, { controlChannel })
}

const setMergeChannel = (state, mergeChannel = {}) => {
  Object.assign(state, { mergeChannel })
}

const updateControlChannel = (state, data) => {
  Object.assign(state, {
    controlChannel: {
      ...(state.controlChannel || {}),
      ...data
    }
  })
}

const setHealthTags = (state, healthTags) => {
  Object.assign(state, { healthTags })
}

const setChannelListener = (state, listener) => {
  if (state.channelListener) {
    state.channelListener()
  }
  state.channelListener = listener
}

const clearChannelListener = state => {
  if (state.channelListener) {
    state.channelListener()
  }
  state.channelListener = null
}

export default {
  setUploadTestResultImageData,
  resetCurrentChannel,
  setCurrentChannel,
  setControlChannel,
  setMergeChannel,
  updateControlChannel,
  setHealthTags,
  setChannelListener,
  clearChannelListener,
  setRawCurrentChannel
}
